
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wevk_1hy7e_11",
  "vertical": "awsui_vertical_1wevk_1hy7e_41",
  "support-prompt": "awsui_support-prompt_1wevk_1hy7e_45"
};
  